import { User } from "../types/api-schema";

import fetchIfAuthorized from "./fetchIfAuthorized";

export default function fetchUserInfo(
  url: string,
  init?: RequestInit,
): Promise<null | User> {
  return fetchIfAuthorized<User>(url, init);
}
